/* eslint-disable @typescript-eslint/no-explicit-any */
import { get } from 'lodash'
import React, { FC, ReactElement } from 'react'
import { Field, Form } from '../input'
import { Container, InputElement, Outside } from './styles'

export type RadioItem = {
  name: string;
  value: string;
}

type InputProps = {
  field?: Field;
  form?: Form;
  label?: string;
  value?: string;
  options: RadioItem[];
  id?: string;
  name: string;
  info?: string | ReactElement | ReactElement[];
  rightAttachment?: ReactElement | string;
  onChange?: {
    (e: React.ChangeEvent<any>): void;
    <T_1 = string | React.ChangeEvent<any>>(field: T_1): T_1 extends React.ChangeEvent<any> ? void : (e: string | React.ChangeEvent<any>) => void;
  };
  onBlur?: (e: any) => any;
}

const InputRadio: FC<InputProps> = ({ form, field, id, info, value: _value, onChange, onBlur, label, rightAttachment, options, name: _name }): ReactElement => {
  const name = field?.name || _name || ''
  const value = field?.value || _value

  const errorMessage = name ? get(form?.errors, name) : null
  const touched = name ? get(form?.touched, name) : null
  const error = touched && errorMessage

  return (
    <Outside id={id}>
      <Container>
        {label && (
          <label>
            {label}
            <div className='right_attachment'>{rightAttachment}</div>
          </label>
        )}
        <div className='input_radio_options'>
          {options.map(option => (
            <div className='option' key={`option-${option.value}`}>
              <InputElement>
                <input
                  type='radio'
                  id={`option-${option.value}`}
                  name={name}
                  value={option.value}
                  checked={option.value === value}
                  onChange={field?.onChange || onChange}
                  onBlur={field?.onBlur || onBlur}
                />
                <label htmlFor={`option-${option.value}`}>
                  <span />
                  {option.name}
                </label>
              </InputElement>
            </div>
          ))}
        </div>
      </Container>
      {error && <span className='error'>{error}</span>}
      {info && <span className='info'>{info}</span>}
    </Outside>
  )
}

export default InputRadio
